<template>
  <Dialog
    :visible="visible"
    modal
    :closable="false"
    :style="{ width: '40rem' }"
    :pt="{
      header: { class: 'p-0' },
      content: { class: 'border-round pt-4' },
    }"
  >
    <div class="flex flex-column align-items-center justify-content-center p-4">
      <!-- Title -->
      <h2 class="text-xl font-bold text-color mb-3">
        {{ translate(`${LOCALE_PREFIX}.ssoRequired.title`) }}
      </h2>

      <!-- Description -->
      <p class="text-color text-center mb-4 line-height-3">
        {{ translate(`${LOCALE_PREFIX}.ssoRequired.description`) }}
      </p>

      <!-- Primary Action Button -->
      <Button
        id="sso-login-button"
        class="w-full mb-3"
        :label="translate(`${LOCALE_PREFIX}.ssoRequired.primaryButton`)"
        @click="handleSsoLogin"
      />

      <!-- Secondary Action Link -->
      <Button
        id="different-account-button"
        class="w-full mb-3"
        text
        :label="translate(`${LOCALE_PREFIX}.ssoRequired.secondaryButton`)"
        @click="handleDifferentAccount"
      />

      <!-- Tertiary Action Link -->
      <div class="text-center">
        {{ translate(`${LOCALE_PREFIX}.ssoRequired.tertiaryButton`) }}
      </div>
    </div>
  </Dialog>
</template>

<script lang="ts" setup>
import { useTranslation } from '@centric-os/helpers';
import { Dialog, Button } from '@centric-os/components';
import { LoginLocalePrefix } from '../../../enums';
import { type PropType } from 'vue';

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  onSsoLogin: {
    type: Function as PropType<() => void>,
  },
  onDifferentAccount: {
    type: Function as PropType<() => void>,
  },
});

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = LoginLocalePrefix.LOGIN;

const handleSsoLogin = () => {
  props.onSsoLogin?.();
};

const handleDifferentAccount = () => {
  props.onDifferentAccount?.();
};
</script>
